import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard } from 'lucide-react';
import { sichtbareReiter } from './reiter';

// #562: Reiter in der Kopfzeile (Desktop). Rendert nur, Regeln in reiter.js.
// #568: `ausgeblendet` und `nurSymbol` kommen aus den Benutzer-Einstellungen.
// Bei „nur Symbol“ tragen alle Reiter ihren Text als aria-label und title,
// das Dashboard bekommt dafür ein Symbol. Der aktive Reiter ist hinterlegt
// (aria-current="page" von NavLink).
const Reiterleiste = ({ user, t, ausgeblendet, nurSymbol = false }) => (
  <>
    {sichtbareReiter(user, 'leiste', ausgeblendet).map(({ id, pfad, Icon, textKey, text, desktopIcon }) => {
      const name = t(textKey, text);
      if (nurSymbol) {
        const Symbol = desktopIcon === false ? LayoutDashboard : Icon;
        return (
          <NavLink key={id} to={pfad} className="kopf-reiter kopf-reiter--symbol" aria-label={name} title={name}>
            <Symbol size={18} />
          </NavLink>
        );
      }
      return desktopIcon === false ? (
        <NavLink key={id} to={pfad}>{name}</NavLink>
      ) : (
        <NavLink key={id} to={pfad} className="kopf-reiter">
          <Icon size={16} />
          <span>{name}</span>
        </NavLink>
      );
    })}
  </>
);

export default Reiterleiste;
